module.exports = __webpack_public_path__ + "static/media/CIRCLES-MOBILE.f5e2abc9.png";